import React, { useState, useCallback, useEffect } from "react";
import {
  Page,
  Card,
  Modal,
  Text,
  FormLayout,
  Filters,
  TextField,
  Badge,
  Frame,
  InlineError,
  ChoiceList,
  Thumbnail,
  EmptySearchResult,
  Link,
  Select,
  Spinner,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { useRef } from "react";
import emptyListImage from "../../Assets/Images/emptyList.svg";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { XIcon, CheckIcon } from "@shopify/polaris-icons";
import Select2 from "react-select";

const OrdersDetails = () => {
  const { id, orderId } = useParams();
  const navigate = useNavigate();
  const [isSaving, setIsSaving] = useState(false);
  const [optionsProfessors, setOptionsProfessors] = useState([]);
  const [selectedProfessor, setSelectedProfessor] = useState("");
  const [selectedSubject, setSelectedSubject] = useState("");

  const handleSelectChangeProfessor = (newValue) => {
    setSelectedProfessor(newValue);
  };
  const [activeModal, setActiveModal] = useState(false);
  const [activeModalReject, setActiveModalReject] = useState(false);
  const [activeModalApprove, setActiveModalApprove] = useState(false);
  const [ts, setTs] = useState("");

  const handleSubmit = () => {
    setIsSaving(true);
    const form_data = new FormData();
    form_data.append("_method", "PATCH");
    form_data.append("status", 2);
    form_data.append("professor_id", selectedProfessor);
    setIsSaving(true);
    axios
      .post(`/requests/${id}/edit-status`, form_data)
      .then((result) => {
        setIsSaving(false);
        setActiveModal(false);
        setTs(+new Date());
      })
      .catch((err) => console.log(err));
  };
  const handleReject = () => {
    const form_data = new FormData();
    form_data.append("_method", "PATCH");
    form_data.append("status", 3);
    setIsSaving(true);
    axios
      .post(`/requests/${id}/edit-status`, form_data)
      .then((result) => {
        setIsSaving(false);
        setActiveModalReject(false);
        setTs(+new Date());
      })
      .catch((err) => console.log(err));
  };
  const handleApprove = () => {};
  const handleChangeModal = () => {
    setActiveModal(false);
  };

  const handleChangeModalReject = () => {
    setActiveModalReject(false);
  };
  const handleChangeModalApprove = () => {
    setActiveModalApprove(false);
  };
  const [result, setResult] = useState("");

  useEffect(() => {
    fetchData();
  }, [ts]);

  async function fetchData() {
    let responseItem = "";

    try {
      responseItem = await axios.get(`/orders/live/${orderId}`);
      console.log("test", responseItem.data);
      setResult(responseItem.data);
    } catch (error) {
      console.log(error);
    }
  }
  const switchStatusColor = (param) => {
    switch (String(param)) {
      case "1":
        return "default";
      case "2":
        return "success";
      case "3":
        return "critical";
      default:
        return "";
    }
  };
  return result ? (
    <Page
      narrowWidth
      backAction={{
        onAction: () => navigate(`/admin/orders/${id}`),
      }}
      title={result?.order_id}
    >
      <Card>
        <FormLayout>
          <FormLayout.Group condensed>
            <Text>
              <b>Order ID</b>
              <br /> {result?.order_id}
            </Text>
            <Text>
              <b>Client Name</b>
              <br />
              {result?.details && result?.details?.client_name
                ? result?.details?.client_name
                : "-"}
            </Text>
            <Text>
              <b>Email</b>
              <br />{" "}
              {result?.details && result?.details?.email
                ? result?.details?.email
                : "-"}
            </Text>
          </FormLayout.Group>

          <FormLayout.Group condensed>
            <Text>
              <b>Phone</b>
              <br />{" "}
              {result?.details && result?.details?.phone
                ? result?.details?.phone
                : "-"}
            </Text>
            <Text>
              <b>City</b>
              <br />
              {result?.details && result?.details?.address?.city
                ? result?.details?.address?.city
                : "-"}
            </Text>
            <Text>
              <b>Country</b>
              <br />
              {result?.details && result?.details?.address?.country
                ? result?.details?.address?.country
                : "-"}
            </Text>
          </FormLayout.Group>

          <FormLayout.Group condensed>
            <Text>
              <b>Price</b>
              <br />
              {result?.details && result?.details?.total !== null
                ? result?.details?.total
                : "-"}
            </Text>
            <Text></Text>
            <Text></Text>
          </FormLayout.Group>
        </FormLayout>
      </Card>

      <Modal
        open={activeModal}
        onClose={handleChangeModal}
        title="Approve Request"
        primaryAction={{
          content: "Submit",
          onAction: handleSubmit,
          loading: isSaving,
        }}
        secondaryActions={[
          {
            content: "Cancel",
            loading: isSaving,
            onAction: handleChangeModal,
          },
        ]}
      >
        <Modal.Section>
          <Select
            label="Please assign a professor"
            options={optionsProfessors}
            onChange={handleSelectChangeProfessor}
            value={selectedProfessor}
            placeholder="Please select"
          />
        </Modal.Section>
      </Modal>

      <Modal
        open={activeModalReject}
        onClose={handleChangeModalReject}
        title="Reject Request"
        primaryAction={{
          content: "Yes",
          onAction: handleReject,
          loading: isSaving,
        }}
        secondaryActions={[
          {
            content: "No",
            loading: isSaving,
            onAction: handleChangeModalReject,
          },
        ]}
      >
        <Modal.Section>
          <Text>Are you sure you want to reject this request?</Text>
        </Modal.Section>
      </Modal>

      <Modal
        open={activeModalApprove}
        onClose={handleChangeModalApprove}
        title="Reject Request"
        primaryAction={{
          content: "Yes",
          onAction: handleApprove,
          loading: isSaving,
        }}
        secondaryActions={[
          {
            content: "No",
            loading: isSaving,
            onAction: handleChangeModalApprove,
          },
        ]}
      >
        <Modal.Section>
          <Text>Are you sure you want to reject this request?</Text>
        </Modal.Section>
      </Modal>
    </Page>
  ) : (
    <div className="spinnerContainer">
      <div className="vertical-center">
        <Spinner size="large" />
      </div>
    </div>
  );
  function getFirstNonNullValue(obj) {
    for (const value of Object.values(obj)) {
      if (value !== null) {
        return value;
      }
    }
    return null;
  }
};

export default OrdersDetails;
